import NavBar from "../components/Nav/NavBar";
import Footer from "../components/Footer";

export default function Privacy() {
  return (
    <div id="root">
      <NavBar />

      <main>
        <h1>Privacy Policy</h1>
        <p>Last updated: 22/06/2026</p>

        <h2>1. Information We Collect</h2>
        <p>
          We only collect personal information that you voluntarily provide through our website forms, such as your email address.
        </p>

        <h2>2. How We Use Your Information</h2>
        <p>
          Any emails you submit are sent directly to our company inbox to respond to inquiries or provide requested information.
          We do not store your emails on the website or in any database.
        </p>

        <h2>3. Cookies and Tracking</h2>
        <p>
          Our website does not use cookies, track IP addresses, or collect other personal information.
          We do not use third-party analytics tools.
        </p>

        <h2>4. Third-Party Hosting</h2>
        <p>
          Our website is hosted by Vercel. Vercel handles the website hosting and delivery but does not have access to your submitted emails.
        </p>

        <h2>5. Data Retention</h2>
        <p>
          Emails submitted through forms remain in our company inbox for as long as necessary to respond to your inquiry and are not retained on the website.
        </p>

        <h2>6. Your Rights</h2>
        <p>
          You may contact us to request access to or deletion of any personal information you have submitted via our contact form.
        </p>

        <h2>7. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us through our website contact form.
        </p>

        <h2>8. Changes to this Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any updates will be posted on this page with a revised “Effective Date.”
        </p>
      </main>

      <Footer />
    </div>
  );
}
